// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Cinematic full-bleed hero ── */

.HeroSection_hero__1mZ-z {
  position: relative;
  width: 100%;
  height: 92vh;
  min-height: 520px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: #0f0a2a;
}

/* Video fills the entire hero */
.HeroSection_heroVideo__B-fg4 {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* Soft vignette around edges for cinematic feel */
.HeroSection_vignette__GuGbG {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  box-shadow: inset 0 0 120px 40px rgba(15, 10, 42, 0.35);
}

/* Gradient from transparent top → dark bottom so text is readable */
.HeroSection_gradientOverlay__R2G1s {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    transparent 30%,
    rgba(15, 10, 42, 0.15) 50%,
    rgba(15, 10, 42, 0.55) 70%,
    rgba(15, 10, 42, 0.85) 88%,
    rgba(15, 10, 42, 0.95) 100%
  );
}

/* ── Content overlay ── */
.HeroSection_content__37-\\+L {
  position: relative;
  z-index: 3;
  max-width: var(--max-width);
  width: 100%;
  padding: 0 2rem 3.5rem;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

/* Greeting tag pill */
.HeroSection_tag__dSdAX {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 1.2rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: rgba(255, 255, 255, 0.95);
  font-family: 'Fredoka', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.72rem;
  border: 1px solid rgba(255, 255, 255, 0.18);
  animation: HeroSection_fadeSlideUp__tN1az 0.8s ease-out both;
}

/* Headline */
.HeroSection_headline__RJIfq {
  font-size: clamp(1.8rem, 4.5vw, 3.2rem);
  margin: 0;
  font-family: 'Fredoka', 'Poppins', sans-serif;
  font-weight: 700;
  line-height: 1.15;
  color: #fff;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
  animation: HeroSection_fadeSlideUp__tN1az 0.8s 0.15s ease-out both;
}

/* Subtitle note */
.HeroSection_note__5OkGI {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  margin: 0;
  font-family: 'Nunito', sans-serif;
  animation: HeroSection_fadeSlideUp__tN1az 0.8s 0.3s ease-out both;
}

/* CTA buttons row */
.HeroSection_actions__vGgDT {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.5rem;
  animation: HeroSection_fadeSlideUp__tN1az 0.8s 0.45s ease-out both;
}

/* Primary CTA */
.HeroSection_btnPrimary__P5cVO {
  padding: 0.85rem 2.2rem !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  font-family: 'Fredoka', sans-serif !important;
  background: linear-gradient(135deg, #7c3aed, #a855f7) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 14px !important;
  box-shadow:
    0 4px 20px rgba(124, 58, 237, 0.4),
    0 0 0 0 rgba(124, 58, 237, 0) !important;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  letter-spacing: 0.02em;
}

.HeroSection_btnPrimary__P5cVO:hover {
  transform: translateY(-3px) scale(1.03) !important;
  box-shadow:
    0 8px 30px rgba(124, 58, 237, 0.5),
    0 0 0 4px rgba(124, 58, 237, 0.15) !important;
}

/* Outline CTA */
.HeroSection_btnOutline__qlNaO {
  padding: 0.85rem 2.2rem !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  font-family: 'Fredoka', sans-serif !important;
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #fff !important;
  border: 2px solid rgba(255, 255, 255, 0.6) !important;
  border-radius: 14px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  letter-spacing: 0.02em;
}

.HeroSection_btnOutline__qlNaO:hover {
  background: rgba(255, 255, 255, 0.18) !important;
  border-color: #fff !important;
  transform: translateY(-3px) scale(1.03) !important;
  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.12) !important;
}

/* Entry animation */
@keyframes HeroSection_fadeSlideUp__tN1az {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Responsive ── */

@media (max-width: 768px) {
  .HeroSection_hero__1mZ-z {
    height: 80vh;
    min-height: 460px;
  }

  .HeroSection_content__37-\\+L {
    padding: 0 1.5rem 3rem;
    gap: 0.85rem;
  }

  .HeroSection_headline__RJIfq {
    font-size: clamp(1.5rem, 5.5vw, 2.4rem);
  }

  .HeroSection_actions__vGgDT {
    gap: 0.75rem;
  }

  .HeroSection_btnPrimary__P5cVO,
  .HeroSection_btnOutline__qlNaO {
    padding: 0.75rem 1.8rem !important;
    font-size: 0.9rem !important;
  }
}

@media (max-width: 480px) {
  .HeroSection_hero__1mZ-z {
    height: 75vh;
    min-height: 400px;
  }

  .HeroSection_content__37-\\+L {
    padding: 0 1rem 2.25rem;
    gap: 0.75rem;
  }

  .HeroSection_headline__RJIfq {
    font-size: clamp(1.25rem, 6vw, 1.8rem);
  }

  .HeroSection_tag__dSdAX {
    font-size: 0.62rem;
    padding: 0.35rem 0.9rem;
  }

  .HeroSection_note__5OkGI {
    font-size: 0.82rem;
  }

  .HeroSection_actions__vGgDT {
    flex-direction: column;
    align-items: stretch;
    gap: 0.65rem;
    width: 100%;
    max-width: 320px;
  }

  .HeroSection_btnPrimary__P5cVO,
  .HeroSection_btnOutline__qlNaO {
    padding: 0.75rem 1.5rem !important;
    font-size: 0.88rem !important;
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}

@media (max-width: 360px) {
  .HeroSection_hero__1mZ-z {
    height: 68vh;
    min-height: 360px;
  }

  .HeroSection_content__37-\\+L {
    padding: 0 0.75rem 2rem;
  }

  .HeroSection_headline__RJIfq {
    font-size: 1.15rem;
  }

  .HeroSection_tag__dSdAX {
    font-size: 0.58rem;
    padding: 0.3rem 0.75rem;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .HeroSection_heroVideo__B-fg4 {
    animation: none;
  }

  .HeroSection_tag__dSdAX, .HeroSection_headline__RJIfq, .HeroSection_note__5OkGI, .HeroSection_actions__vGgDT {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/HeroSection.module.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;;;;;;;GAOC;AACH;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,4DAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,uCAAuC;EACvC,SAAS;EACT,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,0CAA0C;EAC1C,kEAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,iCAAiC;EACjC,iEAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kEAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;EAC7C,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B;;4CAE0C;EAC1C,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD;;iDAE+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;EAC7C,gDAAgD;EAChD,0BAA0B;EAC1B,kCAAkC;EAClC,sBAAsB;EACtB,qDAAqD;EACrD,8BAA8B;EAC9B,qDAAqD;EACrD,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,6BAA6B;EAC7B,kDAAkD;EAClD,2DAA2D;AAC7D;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;;AAErB;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,kCAAkC;IAClC,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,kCAAkC;IAClC,6BAA6B;IAC7B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ── Cinematic full-bleed hero ── */\n\n.hero {\n  position: relative;\n  width: 100%;\n  height: 92vh;\n  min-height: 520px;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  background: #0f0a2a;\n}\n\n/* Video fills the entire hero */\n.heroVideo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n/* Soft vignette around edges for cinematic feel */\n.vignette {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  box-shadow: inset 0 0 120px 40px rgba(15, 10, 42, 0.35);\n}\n\n/* Gradient from transparent top → dark bottom so text is readable */\n.gradientOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  pointer-events: none;\n  background: linear-gradient(\n    to bottom,\n    transparent 30%,\n    rgba(15, 10, 42, 0.15) 50%,\n    rgba(15, 10, 42, 0.55) 70%,\n    rgba(15, 10, 42, 0.85) 88%,\n    rgba(15, 10, 42, 0.95) 100%\n  );\n}\n\n/* ── Content overlay ── */\n.content {\n  position: relative;\n  z-index: 3;\n  max-width: var(--max-width);\n  width: 100%;\n  padding: 0 2rem 3.5rem;\n  text-align: center;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Greeting tag pill */\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 1.2rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  color: rgba(255, 255, 255, 0.95);\n  font-family: 'Fredoka', sans-serif;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.72rem;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  animation: fadeSlideUp 0.8s ease-out both;\n}\n\n/* Headline */\n.headline {\n  font-size: clamp(1.8rem, 4.5vw, 3.2rem);\n  margin: 0;\n  font-family: 'Fredoka', 'Poppins', sans-serif;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #fff;\n  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);\n  animation: fadeSlideUp 0.8s 0.15s ease-out both;\n}\n\n/* Subtitle note */\n.note {\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  margin: 0;\n  font-family: 'Nunito', sans-serif;\n  animation: fadeSlideUp 0.8s 0.3s ease-out both;\n}\n\n/* CTA buttons row */\n.actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 0.5rem;\n  animation: fadeSlideUp 0.8s 0.45s ease-out both;\n}\n\n/* Primary CTA */\n.btnPrimary {\n  padding: 0.85rem 2.2rem !important;\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  font-family: 'Fredoka', sans-serif !important;\n  background: linear-gradient(135deg, #7c3aed, #a855f7) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 14px !important;\n  box-shadow:\n    0 4px 20px rgba(124, 58, 237, 0.4),\n    0 0 0 0 rgba(124, 58, 237, 0) !important;\n  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n  letter-spacing: 0.02em;\n}\n\n.btnPrimary:hover {\n  transform: translateY(-3px) scale(1.03) !important;\n  box-shadow:\n    0 8px 30px rgba(124, 58, 237, 0.5),\n    0 0 0 4px rgba(124, 58, 237, 0.15) !important;\n}\n\n/* Outline CTA */\n.btnOutline {\n  padding: 0.85rem 2.2rem !important;\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  font-family: 'Fredoka', sans-serif !important;\n  background: rgba(255, 255, 255, 0.08) !important;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  color: #fff !important;\n  border: 2px solid rgba(255, 255, 255, 0.6) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;\n  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n  letter-spacing: 0.02em;\n}\n\n.btnOutline:hover {\n  background: rgba(255, 255, 255, 0.18) !important;\n  border-color: #fff !important;\n  transform: translateY(-3px) scale(1.03) !important;\n  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.12) !important;\n}\n\n/* Entry animation */\n@keyframes fadeSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 768px) {\n  .hero {\n    height: 80vh;\n    min-height: 460px;\n  }\n\n  .content {\n    padding: 0 1.5rem 3rem;\n    gap: 0.85rem;\n  }\n\n  .headline {\n    font-size: clamp(1.5rem, 5.5vw, 2.4rem);\n  }\n\n  .actions {\n    gap: 0.75rem;\n  }\n\n  .btnPrimary,\n  .btnOutline {\n    padding: 0.75rem 1.8rem !important;\n    font-size: 0.9rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero {\n    height: 75vh;\n    min-height: 400px;\n  }\n\n  .content {\n    padding: 0 1rem 2.25rem;\n    gap: 0.75rem;\n  }\n\n  .headline {\n    font-size: clamp(1.25rem, 6vw, 1.8rem);\n  }\n\n  .tag {\n    font-size: 0.62rem;\n    padding: 0.35rem 0.9rem;\n  }\n\n  .note {\n    font-size: 0.82rem;\n  }\n\n  .actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.65rem;\n    width: 100%;\n    max-width: 320px;\n  }\n\n  .btnPrimary,\n  .btnOutline {\n    padding: 0.75rem 1.5rem !important;\n    font-size: 0.88rem !important;\n    width: 100%;\n    justify-content: center;\n    text-align: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .hero {\n    height: 68vh;\n    min-height: 360px;\n  }\n\n  .content {\n    padding: 0 0.75rem 2rem;\n  }\n\n  .headline {\n    font-size: 1.15rem;\n  }\n\n  .tag {\n    font-size: 0.58rem;\n    padding: 0.3rem 0.75rem;\n  }\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .heroVideo {\n    animation: none;\n  }\n\n  .tag, .headline, .note, .actions {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `HeroSection_hero__1mZ-z`,
	"heroVideo": `HeroSection_heroVideo__B-fg4`,
	"vignette": `HeroSection_vignette__GuGbG`,
	"gradientOverlay": `HeroSection_gradientOverlay__R2G1s`,
	"content": `HeroSection_content__37-+L`,
	"tag": `HeroSection_tag__dSdAX`,
	"fadeSlideUp": `HeroSection_fadeSlideUp__tN1az`,
	"headline": `HeroSection_headline__RJIfq`,
	"note": `HeroSection_note__5OkGI`,
	"actions": `HeroSection_actions__vGgDT`,
	"btnPrimary": `HeroSection_btnPrimary__P5cVO`,
	"btnOutline": `HeroSection_btnOutline__qlNaO`
};
export default ___CSS_LOADER_EXPORT___;
